export default __webpack_public_path__ + "static/media/vintage100-8.5e2b7c83.jpg";